import mapSliceToComponentUniversal from '~/imports/universal_page'
import { STORYBLOK_SLICES } from '~/lib/storyblok-types'

import EditorialAccordions from '~/components/Slices/EditorialAccordions'
import EditorialSliderImagesWithCaptions from '~/components/Slices/EditorialSliderImagesWithCaptions'
import EditorialText from '~/components/Slices/EditorialText'
import EditorialTwoColumnsImageText from '~/components/Slices/EditorialTwoColumnsImageText'
import EditorialVideo from '~/components/Slices/EditorialVideo'
import ProductTitleSlider from '~/components/Slices/ProductTitleSlider'
import ProductHeader from '~/components/UI/ProductHeader'

export default {
  ...mapSliceToComponentUniversal,
  [STORYBLOK_SLICES.PRODUCT_HEADER]: ProductHeader,
  [STORYBLOK_SLICES.PRODUCT_TITLE_SLIDER]: ProductTitleSlider,
  [STORYBLOK_SLICES.EDITORIAL_TEXT]: EditorialText,
  [STORYBLOK_SLICES.EDITORIAL_TWO_COLUMNS_IMAGE_TEXT]:
    EditorialTwoColumnsImageText,
  [STORYBLOK_SLICES.EDITORIAL_SLIDER_IMAGES_WITH_CAPTIONS]:
    EditorialSliderImagesWithCaptions,
  [STORYBLOK_SLICES.EDITORIAL_VIDEO]: EditorialVideo,
  [STORYBLOK_SLICES.EDITORIAL_ACCORDIONS]: EditorialAccordions,
}
